const initialState = { open: false, etas: [] };
export default initialState;
